<script>
    import { setContext } from "svelte";
    import { flip } from "svelte/animate";

    import Toast from "./Toast.svelte";

    import { TOASTS_KEY } from "./toast";

    export let position;

    const TOAST_KINDS = ["default", "info", "warn", "error", "success"];
    const TOAST_POSITIONS = [
        "top",
        "top-left",
        "top-right",
        "bottom",
        "bottom-left",
        "bottom-right",
        "left",
        "right",
    ];

    $: positionClass = (() => {
        const valid = TOAST_POSITIONS.includes(position);

        if (valid) {
            return position;
        } else {
            return "bottom";
        }
    })();

    setContext(TOASTS_KEY, {
        addToast,
        addPromiseToast,
        getToasts,
        updateToast,
        removeToast,
        removeAllToasts,
    });

    let toasts = [];
    let idCounter = 0;

    function getToasts() {
        return toasts;
    }

    function addToast(toast) {
        const newToast = {
            ...toast,
            id: idCounter.toString(),
        };
        idCounter += 1;

        if (
            newToast.kind === undefined ||
            !TOAST_KINDS.includes(newToast.kind)
        ) {
            newToast.kind = "default";
        }

        toasts = [newToast, ...toasts];
        return newToast;
    }

    function addPromiseToast(promise, options) {
        const toast = addToast({
            ...options.pending,
            kind: "default",
            waiting: true,
        });
        return promise
            .then((value) => {
                updateToast(toast.id, {
                    ...options.success,
                    kind: "success",
                    waiting: false,
                });
                return value;
            })
            .catch((error) => {
                updateToast(toast.id, {
                    ...options.error,
                    kind: "error",
                    waiting: false,
                });
                throw error;
            });
    }

    function updateToast(id, options) {
        toasts = toasts.map((it) => {
            if (it.id === id) {
                return { ...it, ...options, id };
            } else {
                return it;
            }
        });
    }

    function removeToast(id) {
        toasts = toasts.filter((it) => it.id !== id);
    }

    function removeAllToasts() {
        toasts = [];
    }
</script>

<slot />

<div class="container {positionClass}">
    {#each toasts as toast (toast.id)}
        <div class="toast" animate:flip={{ duration: 250 }}>
            <Toast {toast} />
        </div>
    {/each}
</div>

<style>
    .container {
        position: fixed;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .container.bottom {
        bottom: 0px;
        left: 50%;
        transform: translateX(-50%);
        align-items: center;
    }

    .container.bottom-left {
        bottom: 0px;
        left: 5px;
        align-items: flex-start;
    }

    .container.bottom-right {
        bottom: 0px;
        right: 5px;
        align-items: flex-end;
    }

    .container.top {
        top: 5px;
        left: 50%;
        transform: translateX(-50%);
        align-items: center;
    }

    .container.top-left {
        top: 5px;
        left: 5px;
        align-items: flex-start;
    }

    .container.top-right {
        top: 5px;
        right: 5px;
        align-items: flex-end;
    }

    .container.left {
        left: 5px;
        top: 50%;
        transform: translateY(-50%);
        align-items: flex-start;
    }

    .container.right {
        right: 5px;
        top: 50%;
        transform: translateY(-50%);
        align-items: flex-end;
    }

    .toast {
        margin-bottom: 5px;
    }
</style>
